export function normalizeUsername(username) {
  return username ? username.toLowerCase() : username;
}



// WEBPACK FOOTER //
// ./src/store/features/users/helpers.js